<template>
	<div class="main-container">
		<div class="total container-room">
			<div>
				<select-button 
					class="mb-3 field"
					item-text="name"
					item-value="id"
					:items="typesRooms"
					v-model="roomType"
					@change="setRoomTypeIdToAllDays"
				/>
				<select-button
					disabled
					class="mb-3 field"
					item-text="codeRoom"
					item-value="id"
					:items="roomsNumbers"
					v-model="roomNumber"
				/>
				<input-text
					label-text="Tarifa"
					class="field mb-2 white-color"
					v-model="generalRate"
					@input="updateAllRates"
				/>
				<span class="total-amount">Total: {{ totalAmount }}</span>
			</div>
			<div class="close">X</div>
		</div>
		<div
			:class="[
				'number-room',
				'container-room',
				!room.listRooms ? 'not-avaliable' : null,
				!room.idRoom ? 'not-avaliable' : null,
				room.isDirty ? 'dirty-day' : null,
			]"
			v-for="(room, indexRoom) in model"
			:key="indexRoom"
		>
			<select-button
				class="mb-3 field"
				item-text="name"
				item-value="id"
				:items="typesRooms"
				v-model="room.roomTypeId"
				@change="getRoomsNumber($event, room, false)"
			/>
			<select-button
				class="mb-3 field"
				item-text="codeRoom"
				item-value="id"
				:items="room.listRooms"
				v-model="room.idRoom"
				@change="setNumberRoom($event, indexRoom, reservationIndex, model)"
			/>
			<input-text
				label-text="Tarifa"
				class="field"
				type="number"
				v-model.number="room.rate"
				@input="updateRate($event, indexRoom, reservationIndex, model)"
			/>
		</div>
	</div>
</template>

<script>
import { addDays } from 'date-fns';
import selectButton from '@/clerkinn/shared/select-button';
import inputText from '@/clerkinn/shared/input-text';
import helper from '@/shared/helper';
import lib from '@/shared/lib';

const { formatDate } = helper.methods;
const {
	compose,
	setNewProperty,
	updateItemInCollection,
	reduce,
	map,
} = lib;

function mounted() {
	this.loadData();
}

function loadData() {
	this.model = this.roomsByDay.map(this.transformData);
	this.updateAmount(this.model);
	this.setGlobalRoomType(this.model);
}

function setGlobalRoomType(model) {
	const firstRoomTypeId = Number(this.roomsByDay[0].roomTypeId);
	const firstRoomRate = Number(this.roomsByDay[0].rate);
	const equalTypeRoom = model.every(day => day.roomTypeId === firstRoomTypeId);
	const equalRate = this.model.every(day => day.rate === firstRoomRate);
	this.roomType = equalTypeRoom ? firstRoomTypeId : null;
	this.generalRate = equalRate ? firstRoomRate : 0;
}

function transformData(item) {
	const roomTypeId = item.listRooms ? Number(item.roomTypeId) : null;
	const rate = item.rateEdited ? item.rate : this.getRateByDayAndType(item, this.rates);
	const isDirty = item.isDirty || false;
	return compose(
		setNewProperty('rate', rate),
		setNewProperty('rateEdited', item.rateEdited),
		setNewProperty('roomTypeId', roomTypeId),
		setNewProperty('discount', 0),
		setNewProperty('isDirty', isDirty),
	)(item);
}

function getRateByDayAndType(item, rates) {
	if (!item.listRooms) {
		return 0;
	}
	const rateByDate = rates.find(r => r.days === item.days);
	const rateByType = rateByDate.roomTypes.find(r => r.id === Number(item.roomTypeId));
	return Number(rateByType.price);
}

async function getRoomsNumber(roomTypeId, room, flag) {
	this.flag = flag;
	const url = `${process.env.PMS_URL}/roomtype/${this.subsidiary}/rooms/${roomTypeId}`;
	const params = {
		dateInit: room.dateReservation,
		dateEnd: formatDate(addDays(room.dateReservation, 1), 'YYYY-MM-DD'),
	};
	const { data: response } = await this.$http.get(url, { params });
	const listRooms = this.updateListRooms(
		this.reservationIndex,
		response.data,
		room,
		this.allReservation,
	);
	this.updateModel(room, listRooms, this.rates, this.reservationIndex);
	this.updateAmount(this.model);
	this.$emit('update-rooms-selected-data', this.updatedReservations);
}

function updateListRooms(reservationIndex, listRooms, room, reservations) {
	const index = room.days - 1;
	let roomUpdated = setNewProperty('roomTypeId', room.roomTypeId)(room);
	const roomsSelectedByThisType = reduce(
		this.getRoomsSelectedThisDay(index, roomUpdated.roomTypeId),
		reservations,
	);
	const filteredListRooms = reduce(this.removeCommunRoom(roomsSelectedByThisType), listRooms);
	const idRoom = this.flag ? room.idRoom : filteredListRooms[0].id;
	roomUpdated = setNewProperty('idRoom', idRoom)(roomUpdated);
	this.updatedReservations = reduce(
		this.reservationsUpdate(
			index,
			reservationIndex,
			roomUpdated,
			filteredListRooms,
			idRoom,
		),
		reservations,
	);
	return filteredListRooms;
}

function removeCommunRoom(roomsSelected) {
	return function inner(list, item) {
		if (roomsSelected.indexOf(item.id) === -1) {
			return list.concat(item);
		}
		return list;
	};
}

function getRoomsSelectedThisDay(index, roomTypeId) {
	return function inner(list, item) {
		const currentDay = item[index];
		if (roomTypeId === currentDay.roomTypeId && currentDay.idRoom) {
			return list.concat(currentDay.idRoom);
		}
		return list;
	};
}

function updatingNewItem(index, idRoomSelected, roomTypeId, listRooms, item) {
	return compose(
		setNewProperty('idRoom', idRoomSelected),
		setNewProperty('roomTypeId', roomTypeId),
		setNewProperty('listRooms', listRooms),
	)(item[index]);
}

function updatingListRooms(listRooms, idRoom) {
	return listRooms.reduce((arr, room) => {
		if (room.id === idRoom) {
			return arr;
		}
		return arr.concat(room);
	}, []);
}

function reservationsUpdate(index, reserveIndex, room, listRooms, idRoomSelected) {
	return function inner(list, item, itemIndex) {
		const newList = [...list];
		const newItem = [...item];
		if (itemIndex === reserveIndex) {
			newItem[index] = updatingNewItem(
				index,
				idRoomSelected,
				room.roomTypeId,
				listRooms,
				newItem,
			);
			newList.push(newItem);
			return newList;
		}
		if (newItem[index].roomTypeId === room.roomTypeId) {
			newItem[index].listRooms = updatingListRooms(listRooms, room.idRoom);
			newList.push(newItem);
			return newList;
		}
		newList.push(item);
		return newList;
	};
}

function updateModel(room, listRooms, rates, reservationIndex) {
	const newRatePrice = this.getRateByDayAndType(room, rates);
	const idRoom = this.flag ? room.idRoom : listRooms[0].id;
	this.model = this.updatingModel(
		compose(
			updateItemInCollection(room, 'days', 'idRoom', idRoom),
			updateItemInCollection(room, 'days', 'rate', newRatePrice),
			updateItemInCollection(room, 'days', 'listRooms', [...listRooms]),
			updateItemInCollection(room, 'days', 'isDirty', true),
		),
	);
	this.updatedReservations[reservationIndex] = this.model;
}

function updateAmount(collection) {
	this.totalAmount = reduce(this.getMainAmount, collection, 0);
}

function getMainAmount(acc, item) {
	return acc + Number(item.rate);
}

function roomsByDay() {
	this.loadData();
}

function setNumberRoom(idRoom, index, reservationIndex, model) {
	this.isDirty = true;
	let room = model[index];
	room = setNewProperty('idRoom', idRoom)(room);
	const updateReservations = reduce(
		this.updateItemInReservations(index, room, reservationIndex),
		this.allReservation,
	);
	this.$emit('update-rooms-selected-data', updateReservations);
	this.getRoomsNumber(room.roomTypeId, room, true);
}

function updateItemInReservations(index, room, reservationIndex) {
	return function inner(list, itemArray, itemIndex) {
		const newItemArray = [...itemArray];
		const newList = [...list];
		if (reservationIndex === itemIndex) {
			newItemArray[index] = { ...room };
			newList.push(newItemArray);
			return newList;
		}
		newList.push(itemArray);
		return newList;
	};
}

async function setRoomTypeIdToAllDays(roomTypeId) {
	const requests = [
		this.availabilityRoomsByType(roomTypeId, this.subsidiary),
		this.availabilityRoomsByNumber(roomTypeId, this.subsidiary),
	];
	const [availabilityRooms, roomsNumberByType] = await Promise.all(requests);
	this.roomsNumbers = roomsNumberByType.data.data;
	this.fillRooms(availabilityRooms.data.data, roomTypeId);
}

function availabilityRoomsByType(roomTypeId, idSubsidiary) {
	const url = `${process.env.PMS_URL}/availability-rooms`;
	const { endDate, initDate } = this.$route.query;
	const params = {
		dateInit: initDate,
		dateEnd: endDate,
		roomTypeId,
		idSubsidiary,
	};
	return this.$http.get(url, { params });
}

function availabilityRoomsByNumber(roomTypeId, idSubsidiary) {
	const url = `${process.env.PMS_URL}/roomtype/${idSubsidiary}/rooms/${roomTypeId}`;
	const { endDate, initDate } = this.$route.query;
	const params = {
		dateInit: initDate,
		dateEnd: endDate,
	};
	return this.$http.get(url, { params });
}

function fillRooms(fullAvailability, roomTypeId) {
	const majorAvailability = fullAvailability[0];
	const numberOfDays = this.model.length;
	if (majorAvailability.count === numberOfDays) {
		this.roomNumber = majorAvailability.id;
		this.model = this.updatingModel(
			this.progressiveUpdate(majorAvailability, roomTypeId, this.reservationIndex),
		);
	} else {
		this.model = this.updatingModel(
			compose(
				this.setRoomDayByDay(fullAvailability, roomTypeId),
				this.cleanModelInfo(),
			),
		);
	}
}

function setRoomDayByDay(fullAvailability, roomTypeId) {
	const self = this;
	return function inner(item) {
		let newItem = { ...item };
		fullAvailability.forEach((room) => {
			room.availability.dates
			.forEach((date) => {
				newItem = self.checkThisDateAndRoomId(date, room.id, newItem);
			});
		});
		newItem = setNewProperty('roomTypeId', roomTypeId)(newItem);
		self.getRoomsNumber(roomTypeId, newItem, true);
		return newItem;
	};
}

function checkThisDateAndRoomId(date, idRoom, item) {
	let newItem = { ...item };
	if (date === item.dateReservation && !item.idRoom) {
		newItem = setNewProperty('idRoom', idRoom)(newItem);
		return newItem;
	}
	return newItem;
}

function cleanModelInfo() {
	return function inner(item) {
		let newItem = { ...item };
		newItem = compose(
			setNewProperty('idRoom', null),
		)(newItem);
		return newItem;
	};
}

function updatingModel(fn) {
	return map(fn, this.model);
}

function progressiveUpdate(majorAvailability, roomTypeId) {
	const self = this;
	return function inner(item) {
		let room = { ...item };
		room = compose(
			setNewProperty('idRoom', majorAvailability.id),
			setNewProperty('roomTypeId', roomTypeId),
		)(room);
		self.getRoomsNumber(roomTypeId, room, true);
		return room;
	};
}

function updateRate(rate, index, reservationIndex, model) {
	let room = model[index];
	room = compose(
		setNewProperty('rate', rate),
		setNewProperty('rateEdited', true),
	)(room);
	const updateReservations = reduce(
		this.updateItemInReservations(index, room, reservationIndex),
		this.allReservation,
	);
	this.$emit('update-rooms-selected-data', updateReservations);
}

function updateAllRates(rate) {
	this.model = this.model.map(
		compose(
			setNewProperty('rate', Number(rate)),
			setNewProperty('rateEdited', true),
		),
	);
	this.$emit('update-reservation', this.model, this.reservationIndex);
}

function data() {
	return {
		discount: 0,
		generalRate: 0,
		flag: false,
		isDirty: false,
		model: [],
		roomNumber: null,
		roomsNumbers: [],
		roomsTypes: [],
		roomType: null,
		totalAmount: 630.00,
		updatedReservations: [],
	};
}

export default {
	name: 'select-room-number',
	components: {
		inputText,
		selectButton,
	},
	data,
	methods: {
		availabilityRoomsByNumber,
		availabilityRoomsByType,
		cleanModelInfo,
		checkThisDateAndRoomId,
		fillRooms,
		getMainAmount,
		getRateByDayAndType,
		getRoomsSelectedThisDay,
		getRoomsNumber,
		setGlobalRoomType,
		loadData,
		progressiveUpdate,
		removeCommunRoom,
		reservationsUpdate,
		setNumberRoom,
		setRoomDayByDay,
		setRoomTypeIdToAllDays,
		transformData,
		updateAllRates,
		updateAmount,
		updateItemInReservations,
		updateListRooms,
		updateModel,
		updateRate,
		updatingModel,
	},
	mounted,
	props: {
		allReservation: {
			default: () => [],
			type: Array,
		},
		rates: {
			default: () => [],
			type: Array,
		},
		reservationIndex: {
			deafult: 0,
			type: Number,
		},
		roomsByDay: {
			deafult: () => [],
			type: Array,
		},
		subsidiary: {
			default: null,
			type: [Number, String],
		},
		typesRooms: {
			default: () => [],
			type: Array,
		},
	},
	watch: {
		roomsByDay,
	},
};
</script>

<style lang="scss" scoped>
.main-container {
	border-bottom: 1px solid map-get($colors, border-radio);
	display: flex;
	width: fit-content;

	.total {
		background-color: map-get($colors, header-dark) !important;
		border-left: 1px solid map-get($colors, border-radio);
		color: white;
		left: 0;
		position: sticky;
		z-index: 1;
	}

	.container-room {
		background-color: inherit;
		border-right: 1px solid map-get($colors, border-radio);
		border-top: 1px solid map-get($colors, border-radio);
		padding: 22px 10px;
		width: $widthItemDay;
	}

	.total-amount {
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, twelve);
	 }

	 .not-avaliable {
		 background-color: map-get($colors, check-out-transparent);
	 }

	 .dirty-day {
		 background-color: map-get($colors, default-yellow-transparent);
	 }

	 .close {
		 cursor: pointer;
		 font-size: map-get($sizes, fourteen);
		 font-weight: map-get($weights, w-six);
		 position: absolute;
		 right: 5px;
		 top: 0;
	 }

	 .number-room {
		 width: $widthItemDay;
	 }
}
</style>




// WEBPACK FOOTER //
// SelectRoomNumber.vue?ea370c64